import { Link } from 'react-router-dom';
import { ReferenceSelector } from './ReferenceSelector';
import { ReferenceSummary } from './ReferenceSummary';
import type { Tool } from '@/features/traceability/type/Tool';
import { useTranslation } from '@/hooks/useTranslation';

type ReferenceHeaderProps = {
  references: string[];
  selectedReference: string;
  onReferenceChange: (value: string | null) => void;
  tools: Tool[];
  isLoading: boolean;
};

export function ReferenceHeader({
  references,
  selectedReference,
  onReferenceChange,
  tools,
  isLoading,
}: ReferenceHeaderProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between gap-3">
        <ReferenceSelector
          references={references}
          selectedReference={selectedReference}
          onReferenceChange={onReferenceChange}
        />
        <Link
          to="/analytics"
          className="inline-flex items-center text-xs px-3 py-1.5 rounded border border-border text-muted-foreground hover:text-foreground hover:bg-muted transition-colors whitespace-nowrap"
        >
          {t('analytics.classic.backLink')}
        </Link>
      </div>
      <ReferenceSummary tools={tools} selectedReference={selectedReference} isLoading={isLoading} />
    </div>
  );
}
